




































import axios from 'axios';
import mixins from 'vue-typed-mixins';
import { LanguageObject, languageobj } from '@/i18n';
import cloneDeep from 'lodash.clonedeep';
export default mixins().extend({
  props: {
    value: {
      type: String as () => string,
      required: true,
    },
  },

  data(): {
    visible: boolean;
    edit: boolean;
    note: {
      loading: boolean;
      value?: LanguageObject;
      pristine?: LanguageObject;
    };
  } {
    return {
      visible: false,
      edit: false,
      note: {
        loading: false,
        value: undefined,
        pristine: undefined,
      },
    };
  },

  watch: {
    async visible() {
      if (this.visible && !this.note.loading && !this.note.value) {
        this.edit = false;
        this.note.loading = true;
        this.note.pristine = (await getNote(this.value)) || this.$languageobj();
        this.note.value = cloneDeep(this.note.pristine);
        this.note.loading = false;
      } else if (!this.visible) {
        this.edit = false;
        this.note = {
          loading: false,
          value: undefined,
          pristine: undefined,
        };
      }
    },
  },

  methods: {
    async save() {
      const resp = await setNote(this.value, this.note.value as LanguageObject);
      this.edit = false;
      this.note = {
        loading: false,
        value: resp,
        pristine: cloneDeep(resp),
      };
    },
  },
});

const notes = new Map<string, Promise<LanguageObject>>();

const getNote = async (key: string) => {
  let promise = notes.get(key);
  if (!promise) {
    promise = new Promise(async (resolve, reject) => {
      try {
        const resp = await axios.get<any>('/helpText/get.php', {
          params: { key: key },
        });
        resolve(resp.data?.note);
      } catch (error) {
        reject(error);
      }
    });
    notes.set(key, promise);
  }
  return await promise;
};

const setNote = async (key: string, note: LanguageObject) => {
  const resp = await axios.post<{ key: string; note: LanguageObject }>(
    '/helpText/add.php',
    {
      key: key,
      note: note,
    }
  );
  notes.set(key, Promise.resolve(note));
  return note;
};
